<template id="Adresse">
<Modele id="Adresse"/>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Adresse',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Immatriculation/Adresse.vue